import { createFileRoute } from "@tanstack/react-router";
import { EndreSelskapsAvtalePage } from "@/features/avtaler/EndreSelskapsAvtalePage";

export const Route = createFileRoute("/_app/avtaler/$avtalerId/selskap/endre/")(
  {
    component: EndreSelskapsAvtalePage,
    head: () => ({
      meta: [
        {
          title: "Endre bestilling | Norgespris for Fjernvarme",
        },
      ],
    }),
  },
);
